import { render } from "./AppTransition.vue?vue&type=template&id=bbce5bfe"
import script from "./AppTransition.vue?vue&type=script&lang=js"
export * from "./AppTransition.vue?vue&type=script&lang=js"

import "./AppTransition.vue?vue&type=style&index=0&id=bbce5bfe&lang=css"
script.render = render

export default script